export default "__VITE_ASSET__My6J5oMv__"